// extracted by mini-css-extract-plugin
export var content = "type-page-module--content--1262c";
export var rightSidebar = "type-page-module--rightSidebar--3d19b";
export var typePage = "type-page-module--typePage--118b4";
export var typePageContent = "type-page-module--typePageContent--bcab9";